import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import Circle from '../Home/Circle'

class Sidebar extends Component {
    render() {
        return (
            <div>
                <Link to="/blog/bunbury-central-website">
                    <Circle
                        id="7"
                        title1="Bunbury Central"
                        title2="website"
                        month="Nov 20"
                        year="2018"
                        desc="Web Design"
                        image={require('./BunburyCentral/image.jpg')}/>
                </Link>

		<Item
                    to="/blog/developing-a-brand-character"
                    title="Developing a Brand Character"
                    date="18.06.16"
                    category="Design"
                    image={require('./DevelopingABrandCharacter/image.jpg')}/>

                <Item
                    to="/blog/how-google-adwords-works"
                    title="Learn How Google Adwords Works"
                    date="13.04.18"
                    category="Marketing"
                    image={require('./HowGoogleAdwordsWorks/image.jpg')}/>

                <Item
                    to="/blog/websites-vs-social-media-pages"
                    title="Websites vs Social Media Pages"
                    date="23.10.17"
                    category="Marketing"
                    image={require('./WebsiteVsSocialMediaPages/image.jpg')} />
                
                <Item
                    to="/blog/the-darth-vader-guide-to-bad-management"
                    title="The Darth Vader Guide to Bad Management"
                    date="20.05.16"
                    category="Marketing"
                    image={require('./DarthVader/image.jpg')}/>

            </div>
        );
    }
}

const Item = ({image, title, date, category, to}) => <div >
    <Link to={to || "/"} className="recent-item-circle">
        <div
            className="image"
            style={{
            backgroundImage: `url(${image})`
        }}></div>
        <div className="details">
            <div className="title">
                {title || "Developing a Brand Comic Character"}
                <div className="date">
                    {date || "28.01.18"}
                </div>
                <div className="category">{category || "Design"}</div>
            </div>
        </div>
    </Link>
</div>

export default Sidebar;


// WEBPACK FOOTER //
// ./src/Pages/Blog/Sidebar.js